import ReactDOM from "react-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import DeleteIcon from "assets/icons/bin.svg?react";
import {
  TRASH_CONFIRM_HIDE_KEY,
  useTrashConfirmModalStore,
} from "store/trashConfirm.store";

import styles from "./styles.module.scss";

// Globalny modal „Przeniesiono do kosza" — montowany raz w App.tsx, sterowany
// store'em. Wygląd wg projektu Figma. Checkbox „Nie pokazuj ponownie" zapisuje
// wybór w localStorage i wycisza modal na przyszłość.
const TrashMovedModal = () => {
  const { t } = useTranslation();
  const isOpen = useTrashConfirmModalStore((s) => s.isOpen);
  const close = useTrashConfirmModalStore((s) => s.close);

  const [dontShowAgain, setDontShowAgain] = useState(false);

  if (!isOpen) {
    return null;
  }

  const handleClose = () => {
    if (dontShowAgain) {
      localStorage.setItem(TRASH_CONFIRM_HIDE_KEY, "true");
    }
    close();
  };

  return ReactDOM.createPortal(
    <div className={styles.modal} onClick={handleClose}>
      <div className={styles.wrapper} onClick={(e) => e.stopPropagation()}>
        <div className={styles.content}>
          <div className={styles.icon}>
            <DeleteIcon />
          </div>
          <div className={styles.title}>{t("trashMovedModal.title")}</div>
          <div className={styles.body}>{t("trashMovedModal.body")}</div>

          <div
            className={styles.checkboxRow}
            onClick={() => setDontShowAgain((v) => !v)}
          >
            <div
              className={`${styles.checkbox} ${
                dontShowAgain ? styles.checkboxChecked : ""
              }`}
            >
              {dontShowAgain && (
                <FontAwesomeIcon className={styles.checkIcon} icon={faCheck} />
              )}
            </div>
            <span className={styles.checkboxLabel}>
              {t("trashMovedModal.dontShowAgain")}
            </span>
          </div>
        </div>

        <div className={styles.actions}>
          <button className={styles.secondaryBtn} onClick={handleClose}>
            {t("trashMovedModal.close")}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default TrashMovedModal;
